import _ from "lodash";
import { log2 } from "../../utils/log2";
import { CHATBOT_API } from "../../api/chatbotv2";
import CONFIG from "../../config/config";

const log = log2("CBStore");

const CB = {
    namespaced: true,
    state: {
        stories: [],
        boards: [],
        selectedBoard: "1.0",
        testConversationId: null,
        akinonEnabled: CONFIG.AKINON.enabled,
        userEntities: [],
        allWebHooks: [],
        segments: [],
        tags: [],
        settings: null,
    },
    getters: {
        board: (state) => (id) => state.boards.find((x) => x.story === id && x.version === state.selectedBoard),
        getStoryById: (state) => (id) => state.stories.find((x) => x._id === id),
        versions: (state) => (id) => {
            const versions = _.get(
                state.stories.find((x) => x.id === id),
                "meta.versions"
            );
            const sortedVersions = _.orderBy(versions, ["publishDate", "version"], ["desc"])
            ;
            return sortedVersions;
        },
        allBoards: (state) => (id) =>
            _.sortBy(
                state.boards.filter((x) => x.story === id),
                (x) => -x.version
            ),
        settings: (state) => (id) =>
            _.get(
                state.stories.find((x) => x.id === id),
                "settings"
            ),
    },
    mutations: {
        UPDATE_SETTINGS(state, payload) {
            let storyIndex = state.stories.findIndex((x) => x.id === payload.id);
            if (storyIndex !== -1) {
                if (payload.language !== undefined) state.stories[storyIndex].settings.language = payload.language;
                if (payload.navigation !== undefined) state.stories[storyIndex].settings.navigation = payload.navigation;
                if (payload.confidence !== undefined) state.stories[storyIndex].settings.confidence = payload.confidence;
                if (payload.handleFirstMessageEnabled !== undefined) {
                    state.stories[storyIndex].settings.handleFirstMessageEnabled = payload.handleFirstMessageEnabled;
                }
            } else {
                log.error("UPDATE_SETTINGS", "story not found");
            }
        },
        UPDATE_STORY_NAME(state, data) {
            let storyIndex = state.stories.findIndex((x) => x.id === data._id);
            if (storyIndex !== -1) {
                if (data.title !== undefined) state.stories[storyIndex].title = data.title;
            } else {
                log.error("UPDATE_SETTINGS", "story not found");
            }
        },
        CHANGE_BOARD(state, payload) {
            state.selectedBoard = payload;
        },
        ADD_STORY(state, payload) {
            log("ADD_STORY", payload);
            let removeIndex;
            if (removeIndex !== -1) state.stories.splice(removeIndex, 1);
            state.stories.push(payload);
        },
        SET_STORY(state, payload) {
            log("SET_STORY", payload);
            state.stories = payload;
        },
        ADD_BOARD(state, payload) {
            log("ADD_BOARD", payload);
            let removeIndex = state.boards.findIndex((x) => x.id === payload.id);
            if (removeIndex !== -1) state.boards.splice(removeIndex, 1);
            state.boards.push(payload);
        },
        UPDATE_BOARD(state, payload) {
            log("UPDATE_BOARD", payload);
            state.boards = state.boards.map((x) => (x.id === payload.id ? payload : x));
        },
        SET_CONVERSATION(state, conversationId) {
            state.testConversationId = conversationId;
        },
        SET_USER_ENTITIES(state, entities) {
            state.userEntities = entities;
        },
        DELETE_FROM_STORY(state, payload) {
            state.stories = state.stories.filter((story) => story._id !== payload);
        },
        SET_ALL_WEB_HOOKS(state, webHooks) {
            state.allWebHooks = webHooks;
        },
        UPDATE_WEBHOOK_LIST(state, webhook) {
            state.allWebHooks = [...state.allWebHooks, webhook];
        },
        UPDATE_WEBHOOK(state, id) {
            state.allWebHooks = state.allWebHooks((webhook) => {
                if (webhook.id === id) {
                    return webhook;
                }
                return webhook;
            });
        },
        SET_SETTINGS(state, { settings, storyId }) {
            let storyIndex = state.stories.findIndex((x) => x.id === storyId);
            if (storyIndex !== -1) {
                Object.keys(settings).forEach((key) => {
                    state.stories[storyIndex].settings[key] = settings[key];
                });
            } else {
                log.error("SET_SETTINGS", "story not found");
            }
        },

    },
    actions: {
        async listStories({ commit }) {
            try {
                let { data } = await CHATBOT_API.listStories();
                log("listStories", data);
                data = data.map((x) => {
                    x.id = x._id;
                    return x;
                });
                commit("SET_STORY", data);
                return data;
            } catch (e) {
                log.error(e);
            }
        },
        async getStory({ state, commit }, payload) {
            try {
                const { data } = await CHATBOT_API.getStory(payload);
                log("getStory", data);
                data.data.story.id = data.data.story._id;
                data.data.board.id = data.data.board._id;
                commit("ADD_STORY", data.data.story);
                commit("ADD_BOARD", data.data.board);
                commit("CHANGE_BOARD", data.data.board.version);
                return data.data.story;
            } catch (e) {
                log.error(e);
            }
        },
        async updateStory({ state, commit }, payload) {
            try {
                const { data } = await CHATBOT_API.getStory(payload);
                log("getStory", data);
                data.data.story.id = data.data.story._id;
                data.data.board.id = data.data.board._id;
                commit("ADD_STORY", data.data.story);
                commit("ADD_BOARD", data.data.board);
                return data.data.story;
            } catch (e) {
                log.error(e);
            }
        },
        async updateStoryName({ state, commit }, payload) {
            try {
                log("updateStoryName p", payload);
                const { data } = await CHATBOT_API.updateStoryName(payload);
                log("updateStoryName d", data);
                commit("UPDATE_STORY_NAME", data);
            } catch (e) {
                log.error(e);
            }
        },
        async deleteSingleBlock({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.deleteSingleBlock(payload);
                log("deleteSingleBlock", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
                return data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async deleteWithChildren({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.deleteWithChildren(payload);
                log("deleteWithChildren", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
            } catch (e) {
                log.error(e);
            }
        },
        async updateBlock({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.updateBlock(payload);
                log("updateBlock", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
            } catch (e) {
                log.error(e);
            }
        },
        async undoDiagram({ commit }, { id, version }) {
            try {
                const { data } = await CHATBOT_API.undoDiagram(id, version);
                log("undoDiagram", { id, version }, "result", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
                return Promise.resolve(data);
            } catch (e) {
                log.error(e);
            }
        },
        async redoDiagram({ commit }, { id, version }) {
            try {
                const { data } = await CHATBOT_API.redoDiagram(id, version);
                log("undoDiagram", { id, version }, "result", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
                return Promise.resolve(data);
            } catch (e) {
                log.error(e);
            }
        },
        async addBlock({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.addBlock(payload);
                log("addBlock", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
                return Promise.resolve(data);
            } catch (e) {
                log.error(e);
            }
        },
        async moveBlock({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.moveBlock(payload);
                log("moveBlock", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
                return data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async copyBlock({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.copyBlock(payload);
                log("moveBlock", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
                return data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async updateBoardSingleKey({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.updateBoardSingleKey(payload);
                log("updateBoardSingleKey", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
            } catch (e) {
                log.error(e);
            }
        },
        async addCustomAttributeToBoard({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.addCustomAttribute(payload);
                log("addCustomAttributeToBoard", data);
                data.id = data._id;
                commit("UPDATE_BOARD", data);
            } catch (e) {
                log.error(e);
            }
        },
        async listSegments({ state }) {
            try {
                const { data } = await CHATBOT_API.USER_SEGMENTS.listSegments();
                state.segments = data;
                return data;
            } catch (e) {
                log.error(e);
            }
        },
        async listTags({ state }) {
            try {
                const { data } = await CHATBOT_API.TAGS.listTags();
                state.tags = data;
                return data;
            } catch (e) {
                log.error(e);
            }
        },
        async createNewSegment({}, payload) {
            try {
                const { data } = await CHATBOT_API.USER_SEGMENTS.createSegment(payload);
                log("createSegment", data);
                return data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async addUserToSegment({}, payload) {
            try {
                const { data } = await CHATBOT_API.USER_SEGMENTS.addUserToSegment(payload);
                log("add Segment", data);
                return data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async updateSegment({}, payload) {
            try {
                const { data } = await CHATBOT_API.USER_SEGMENTS.updateSegment(payload);
                log("update Segment", data);
                return data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async deleteSegment({ dispatch }, payload) {
            try {
                const { data } = await CHATBOT_API.USER_SEGMENTS.deleteUserFromSegment(payload);
                if (data === true) dispatch("listSegments");
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async deleteAllStories({ commit }) {
            try {
                CHATBOT_API.deleteAllStories();
            } catch (e) {
                log.error(e);
            }
        },
        async deleteStory({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.deleteStory(payload);
                if (data) {
                    commit("DELETE_FROM_STORY", payload);
                }
            } catch (e) {
                log.error(e);
            }
        },
        async duplicateStory({ commit, dispatch }, payload) {
            try {
                const { data } = await CHATBOT_API.duplicateStory(payload);
                log("duplicateStory store", data);
                dispatch("listStories");
            } catch (e) {
                log.error(e);
            }
        },
        async makeDefaultStory({ commit, dispatch }, payload) {
            log("makeDefaultStory store payload", payload);
            try {
                const { data } = await CHATBOT_API.makeDefaultStory(payload);
                log("makeDefaultStory store", data);
                dispatch("listStories");
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async revokeDefaultStory({ commit, dispatch }, payload) {
            try {
                const { data } = await CHATBOT_API.revokeDefaultStory(payload);
                log("revokeDefaultStory store", data);
                dispatch("listStories");
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async createEmptyStory({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.createEmptyStory(payload);
                log("createEmptyStory", data);
                data.data.story.id = data.data.story._id;
                data.data.board.id = data.data.board._id;
                commit("ADD_STORY", data.data.story);
                commit("ADD_BOARD", data.data.board);
                commit("CHANGE_BOARD", data.data.board.version);
                return data.data;
            } catch (e) {
                log.error(e);
                return e;
            }
        },
        async createStoryFromTemplate({ commit }, slug) {
            try {
                const { data } = await CHATBOT_API.createStoryFromTemplate(slug);
                log("createStoryFromTemplate", data);
                if (data) {
                    data.data.story.id = data.data.story._id;
                    data.data.board.id = data.data.board._id;
                    commit("ADD_STORY", data.data.story);
                    commit("ADD_BOARD", data.data.board);
                    commit("CHANGE_BOARD", data.data.board.version);
                    return data.data;
                }
                return false;
            } catch (e) {
                log.error(e);
                return false;
            }
        },
        async createStoryFromDiagram({ commit }, board) {
            try {
                const { data } = await CHATBOT_API.createStoryFromDiagram(board);
                log("createStoryFromDiagram", data);
                if (data) {
                    data.data.story.id = data.data.story._id;
                    data.data.board.id = data.data.board._id;
                    commit("ADD_STORY", data.data.story);
                    commit("ADD_BOARD", data.data.board);
                    commit("CHANGE_BOARD", data.data.board.version);
                    return data.data;
                }
                return false;
            } catch (e) {
                log.error(e);
                return false;
            }
        },
        async publishBoard({ commit, dispatch }, payload) {
            try {
                await CHATBOT_API.publishBoard(payload);
                log("publishBoard");
                await dispatch("listStories");
                await dispatch("getStory", { id: payload.id, version: payload.publishVersion });
                const router = require("../../router").default;
                router.push(`/chatbot/story/${payload.id}/${payload.publishVersion}`);
            } catch (e) {
                log.error(e);
            }
        },
        async updateVersionName({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.updateVersionName(payload);
                log("updateVersionName");
            } catch (e) {
                log.error(e);
            }
        },
        async restore({ commit, dispatch }, payload) {
            try {
                const { data } = await CHATBOT_API.restore(payload);
                log("restore", data);
                await dispatch("listStories");
                await dispatch("getStory", { id: payload.storyId, version: data.version });
                const router = require("../../router").default;
                router.push(`/chatbot/story/${payload.storyId}/${data.version}`);
            } catch (e) {
                log.error(e);
            }
        },
        async fetchUserEntities({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.getEntities(payload);
                commit("SET_USER_ENTITIES", data);
            } catch (e) {
                log.error(e);
            }
        },
        async fetchUserWebHooks({ commit }) {
            try {
                const { data } = await CHATBOT_API.getAllWebHooks();
                commit("SET_ALL_WEB_HOOKS", data);
                return data;
            } catch (e) {
                log.error(e);
            }
        },
        async fetchUserWebHook({ commit }) {
            try {
                const { data } = await CHATBOT_API.getAllWebHooks();
                commit("SET_WEB_HOOK", data);
                return data;
            } catch (e) {
                log.error(e);
            }
        },
        async createNewWebHook({ commit }, payload) {
            try {
                const { data } = await CHATBOT_API.addWebHook(payload);
                commit("UPDATE_WEBHOOK_LIST", data);
            } catch (e) {}
        },
        async updateWebHook({ commit }, { id, payload }) {
            try {
                const { data } = await CHATBOT_API.updateWebHook(id, payload);
                commit("UPDATE_WEBHOOK", data.id);
            } catch (e) {}
        },
        async updateSettings({ commit, state }, payload) {
            try {
                const { storyId, settings } = payload;
                const response = await CHATBOT_API.updateSettings(storyId, settings);
                commit("SET_SETTINGS", payload);
            } catch (error) {
                console.error("Error updating settings:", error);
            }
        },
    },
};

export default CB;
